// src/components/Layout/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../../assets/images/branding-vanguard5.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Top line */}
        <div className="footer-top-line"></div>
        
        {/* Footer Top Section */}
        <div className="footer-top">
          {/* Quick Links - Left side */}
          <div className="quick-links">
            <h4 className="footer-title">Quick links</h4>
            <ul className="quick-links-list">
              <li><Link to="/">HOME</Link></li>
              <li><Link to="/what-we-do">WHAT WE DO</Link></li>
              <li><Link to="/people-career">PEOPLE AND CAREER</Link></li>
            </ul>
          </div>

          {/* Social & Contact - Right side */}
          <div className="social-contact">
            {/* Social Section */}
            <div className="social-section">
              <h4 className="footer-title">Social</h4>
              <div className="social-icons">
                <a 
                  href="https://www.instagram.com/vanguardfsg?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label="Instagram"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a 
                  href="https://www.linkedin.com/company/vanguard-facility-services-group/posts/?feedView=all" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label="LinkedIn"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>

            {/* Contact Section */}
            <div className="contact-section">
              <h4 className="footer-title">Get in Touch</h4>
              <Link to="/contact-us" className="contact-link-footer">
                CONTACT US
              </Link>
            </div>
          </div>
        </div>

        {/* Footer Bottom Section */}
        <div className="footer-bottom">
          {/* Copyright - Left */}
          <div className="copyright-left">
            <p>&copy; {new Date().getFullYear()} Vanguard Facilities Services Group. All rights reserved.</p>
          </div>

          {/* Logo - Center */}
          <div className="logo-center">
            <img src={logo} alt="Vanguard" className="footer-logo" />
          </div>

          {/* Address - Right */}
          <div className="address-right">
            <p>Suite 106/32 Pirrama Rd, Pyrmont NSW 2009</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;